import intl from 'react-intl-universal';
import axios from 'axios';
import {localeLang} from '../../public/currentLocale';

export function MutiInit(moduleId, callback) {
    let _dir = NODE_ENV == 'development' ? '../src/platform/public/lang/' : '../../../public/lang/';
    let currentLocale = localeLang || 'simpchn';
    if (moduleId) {
        // axios.get(`${_dir}customer/${currentLocale}/${moduleId}.json`)
        axios.get(`${_dir}standard/${currentLocale}/${moduleId}.json`)
            .then(res => {
                if (res) {
                    intl.init({
                        currentLocale,
                        locales: {
                            [currentLocale]: res.data
                        }
                    });
                    this.state.intl[moduleId] = intl;
                    this.setState({intl: this.state.intl}, () => {
                        callback && callback( res.data, true, intl)
                    })
                }
            }).catch(() => {
            //  加载industry
            axios
                .get(`${_dir}industry/${currentLocale}/${moduleId}.json`)
                .then(res => {
                    if (res) {
                        intl.init({
                            currentLocale,
                            locales: {
                                [currentLocale]: res.data
                            }
                        });
                        if (this.state.intl) {
                            this.state.intl = {};
                        }
                        this.state.intl[moduleId] = intl;
                        this.setState({intl: this.state.intl}, () => {
                            callback && callback( res.data, true, intl)
                        })
                    }
                }).catch(() => {
                //  加载standard
                // axios.get(`${_dir}standard/${currentLocale}/${moduleId}.json`)
                axios.get(`${_dir}customer/${currentLocale}/${moduleId}.json`)
                    .then(res => {
                        // console.log(moduleId, '------')
                        if (res) {
                            intl.init({
                                currentLocale,
                                locales: {
                                    [currentLocale]: res.data
                                }
                            });
                            if (this.state.intl) {
                                this.state.intl = {};
                            }
                            this.state.intl[moduleId] = intl;
                            this.setState({intl: this.state.intl}, () => {
                                callback && callback( res.data, true, intl)
                            })
                        }
                    }).catch((res) => {
                    callback && callback( res.data, false, intl)
                })

            })

        })
    }
}
